/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React, { useRef, useState, useCallback } from 'react';
import Button from '@xanadu/ui-shared/components/widgets/Button';
import styles from './Rating.module.scss';

const Star = ({
  selected = false,
  onClick = f => f,
}) => {
  let classes;
  if (selected) {
    classes = `${styles.star} ${styles['star--selected']}`;
  } else {
    classes = styles.star;
  }

  return (
    <div
      role="button"
      className={classes}
      onClick={onClick}
    />
  );
};

Star.propTypes = {
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,

};

export default function Rating({
  totalStars,
  releaseDate,
  releaseDescription,
  userId
}) {
  const feedbackInput = useRef();
  const [starsSelected, selectStar] = useState(0);
  const [rated, setRated] = useState(false);
  const [feedback, setFeedback] = useState('');

  const handleTextFeedback = useCallback((e) => {
    setFeedback(e.target.value);
  });

  const handleStarSelection = useCallback((index) => {
    selectStar(index + 1);
  });

  const handleButtonClick = useCallback(() => {
    setRated(true);
  });

  if (rated) {
    return (
      <div className={styles.starRating}>
        <div className={styles.header} />
        <div className={styles.starsContainer}>
          <div className={styles.label}>Thank you for your feedback.</div>
        </div>
      </div>
    );
  }
  const stars = [...Array(totalStars).keys()];
  return (
    <div className={styles.starRating}>
      <div className={styles.header}>Your feedback would be appreciated.</div>
      <div className={styles.starsContainer}>
        <div className={styles.label}>How would you rate this update?</div>
        <div className={styles.starsRow}>
          {stars.map((n, i) => (
            <Star
              key={stars[n]}
              selected={i < starsSelected}
              onClick={() => {
                handleStarSelection(i);
              }}
            />
          ))}
        </div>
      </div>
      <textarea
        ref={feedbackInput}
        className={styles.feedback}
        onChange={(e) => handleTextFeedback(e)}
        placeholder="Your feedback..."
        maxLength="280"
        value={feedback}
      />
      <div className={styles.buttonContainer}>
        <span className={styles.limitText}>
          {`Character Limit: ${280 - feedback.length}/280`}
        </span>
        <Button
          disabled={starsSelected === 0}
          sizeType="small-mobile"
          buttonType="primary"
          onClick={() => {
            handleButtonClick();
            try {
              localStorage.setItem('mb-user-rating', releaseDate);

              const payload = {
                feedback,
                'release-date': releaseDate,
                'release-description': releaseDescription,
                'stars-selected': starsSelected,
                'account-id': userId,
                resolution: `${window.screen.availWidth}x${window.screen.availHeight}`,
                'user-agent': window.navigator.userAgent
              };

              fetch('/bpapi/rest/release-feedback', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json'
                },
                credentials: 'same-origin',
                body: JSON.stringify(payload)
              });
            } catch (e) {
              // eslint-disable-next-line no-console
              console.error('Couldn\'t set user feature rating into localStorage', e);
            }
          }}
        >Send</Button>
      </div>
    </div>
  );
}

Rating.propTypes = {
  totalStars: PropTypes.number.isRequired,
  releaseDate: PropTypes.string.isRequired,
  releaseDescription: PropTypes.string.isRequired,
  userId: PropTypes.number
};
